var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tagName,_vm._b({tag:"component"},'component',_vm.attrs,false),[_vm._v(_vm._s(_vm.attrs.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }